import styled from 'styled-components'
import { PRIMARY_COLOR } from '../../../../../styles/colors.style'
import { breakpoints } from '../../../../../constants'

export const StyledSectionHeader = styled.div`
	font-size: 3.2rem;
	color: ${PRIMARY_COLOR};
	border-bottom: 1px solid ${PRIMARY_COLOR};
	padding-bottom: 1rem;
	margin-top: 20px;
	display: flex;
	justify-content: space-between;
`

export const StyledForm = styled.form`
	padding-top: 2rem;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		.col1,
		.col2 {
			display: grid;
			grid-gap: 15px;
			align-items: end;
		}

		.col1 {
			grid-template-columns: repeat(4, 1fr);
		}

		.col2 {
			grid-template-columns: repeat(6, 1fr);
		}
	}
`
